import { render } from "./NewProject.vue?vue&type=template&id=4a3604e0&scoped=true"
import script from "./NewProject.vue?vue&type=script&lang=js"
export * from "./NewProject.vue?vue&type=script&lang=js"

import "./NewProject.vue?vue&type=style&index=0&id=4a3604e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javier.padilla\\git-repositories\\proyectos.ges.com\\com.ges.proyectos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3604e0"]])

export default __exports__